import { CLEAR_REGISTER_DATA, SET_REGISTER_DATA } from "./types";

export default {
  [SET_REGISTER_DATA] (state, payload) {
    state[payload.field] = payload.value
  },
  [CLEAR_REGISTER_DATA] (state) {
    let data = {
      UserName: null,
      UserPass: null,
      UserPassConfirm: null,
      UserPass2: null,
      UserPass2Confirm: null,
      UserSA: null,
      UserEmail: null,
      referralCode: null,
      token: null
    }

    Object.assign(state, data)
  }
}